// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"home_bannerContainer__pzs34","bgImg":"home_bgImg__xuX_C","wrapper":"home_wrapper___c8jW"};